// src/pages/Account.js
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthHeaders } from "../services/authHeaders";
import { User } from "lucide-react";

const inputCls = "w-full px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-transparent text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none";
const labelCls = "block text-xs mb-1 text-slate-600 dark:text-slate-300 font-medium";

const XANO_BASE_URL = "https://api.sobevenda.com.br/api-proxy/script";

function Account() {
  const [formData, setFormData] = useState({ name: "", email: "", password: "", new_password: "", confirm_password: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${XANO_BASE_URL}/get-configuration`, { headers: getAuthHeaders() })
      .then((res) => setFormData((prev) => ({ ...prev, name: res.data.name, email: res.data.email })))
      .catch((err) => toast.error(err?.response?.data?.message || "Sessão expirada. Faça login novamente."))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, plan, password, new_password, confirm_password } = formData;
    if (new_password && new_password !== confirm_password) { toast.error("Nova senha e confirmação não coincidem."); return; }
    axios.patch(`${XANO_BASE_URL}/update-configuration`, { name, email, plan, password, new_password }, { headers: getAuthHeaders() })
      .then(() => toast.success("Perfil atualizado com sucesso!"))
      .catch(() => toast.error("Erro ao atualizar perfil."));
  };

  if (loading) {
    return (
      <div className="p-4 md:p-6">
        <div className="max-w-lg animate-pulse space-y-4">
          <div className="h-7 w-32 rounded bg-slate-200 dark:bg-slate-800" />
          <div className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-5 space-y-3">
            {[1,2,3,4,5].map((i) => <div key={i} className="h-10 rounded-lg bg-slate-100 dark:bg-slate-800" />)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6">
      <div className="max-w-lg space-y-6">

        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-2">
            <User className="w-6 h-6" /> Perfil
          </h1>
          <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">Gerencie suas informações de conta.</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-5 space-y-4">

          <div>
            <label className={labelCls} htmlFor="name">Nome</label>
            <input id="name" type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Seu nome" className={inputCls} />
          </div>

          <div>
            <label className={labelCls} htmlFor="email">Email</label>
            <input id="email" type="email" name="email" value={formData.email} disabled
              className={`${inputCls} opacity-60 cursor-not-allowed`} />
          </div>

          <div className="pt-2 border-t border-slate-100 dark:border-slate-800">
            <p className="text-xs text-slate-500 dark:text-slate-400 mb-3">Deixe em branco para manter a senha atual.</p>

            <div className="space-y-4">
              <div>
                <label className={labelCls} htmlFor="password">Senha atual</label>
                <input id="password" type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Digite sua senha atual" className={inputCls} />
              </div>
              <div>
                <label className={labelCls} htmlFor="new_password">Nova senha</label>
                <input id="new_password" type="password" name="new_password" value={formData.new_password} onChange={handleChange} placeholder="Digite a nova senha" className={inputCls} />
              </div>
              <div>
                <label className={labelCls} htmlFor="confirm_password">Confirmar nova senha</label>
                <input id="confirm_password" type="password" name="confirm_password" value={formData.confirm_password} onChange={handleChange} placeholder="Repita a nova senha" className={inputCls} />
              </div>
            </div>
          </div>

          <button type="submit"
            className="w-full inline-flex items-center justify-center px-4 py-2.5 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100">
            Salvar alterações
          </button>
        </form>
      </div>
    </div>
  );
}

export default Account;